import { useEffect, useRef } from "react";

export default function CtaSection() {
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.querySelectorAll(".cta-item").forEach((item, i) => {
              setTimeout(() => item.classList.add("cta-visible"), i * 120);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="py-16 lg:py-20 bg-white" ref={sectionRef}>
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="relative rounded-3xl overflow-hidden">
          {/* Background */}
          <img
            src="https://readdy.ai/api/search-image?query=modern%20corporate%20city%20skyline%20at%20night%20with%20golden%20lights%2C%20premium%20business%20district%2C%20sophisticated%20urban%20landscape%2C%20dark%20atmospheric%20photography%2C%20professional%20executive%20environment&width=1400&height=600&seq=cta001&orientation=landscape"
            alt="CTA Background"
            className="absolute inset-0 w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-black/75" />

          {/* Decorative yellow accent */}
          <div className="absolute top-0 left-0 w-1 h-full bg-[#FBC52D]" />
          <div className="absolute bottom-0 left-0 right-0 h-px bg-[#FBC52D]/20" />

          {/* Content */}
          <div className="relative z-10 px-8 md:px-14 lg:px-20 py-16 lg:py-20">
            <div className="max-w-3xl">
              <div className="cta-item opacity-0 translate-y-6 transition-all duration-500 inline-flex items-center gap-2 mb-6">
                <span className="w-6 h-px bg-[#FBC52D]" />
                <span className="text-[#FBC52D] text-xs font-semibold tracking-widest uppercase">
                  Próximo passo
                </span>
              </div>

              <h2 className="cta-item opacity-0 translate-y-6 transition-all duration-500 text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
                Quer acelerar os resultados da sua empresa?
              </h2>

              <p className="cta-item opacity-0 translate-y-6 transition-all duration-500 text-white/70 text-lg leading-relaxed mb-10 max-w-xl">
                Agende uma análise gratuita com nossos especialistas e descubra como reduzir custos, reter talentos e aumentar a produtividade.
              </p>

              <div className="cta-item opacity-0 translate-y-6 transition-all duration-500 flex flex-col sm:flex-row gap-4">
                <button
                  onClick={() => document.querySelector("#contato")?.scrollIntoView({ behavior: "smooth" })}
                  className="whitespace-nowrap bg-[#FBC52D] text-black font-semibold px-8 py-4 rounded-full hover:bg-[#d4a800] transition-all duration-200 cursor-pointer text-sm"
                >
                  Solicitar análise gratuita
                </button>
                <a
                  href="https://wa.me/5511936189998"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="whitespace-nowrap flex items-center justify-center gap-2 border border-white/30 text-white font-semibold px-8 py-4 rounded-full hover:bg-white/10 hover:border-white/60 transition-all duration-200 cursor-pointer text-sm"
                >
                  <i className="ri-whatsapp-line text-base" />
                  Falar pelo WhatsApp
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .cta-visible {
          opacity: 1 !important;
          transform: translateY(0) !important;
        }
      `}</style>
    </section>
  );
}